module.exports = __webpack_public_path__ + "7dc51eb265959ac0bb1b1ec3fc0ef577.pdf";